import React, { useEffect, useRef, useState } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../../../styles/select-style'
import axios from '../../../../../config/axios'
import { X } from 'lucide-react'

interface MachineItemType {
  id: number
  name: string
  model: string
}

interface PropsType {
  machines: MachineItemType[]
  setMachines: React.Dispatch<React.SetStateAction<MachineItemType[]>>
}

const SelectMachineInService:React.FC<PropsType> = ({machines, setMachines}) => {
  const [ items, setItems ] = useState<MachineItemType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    setInputItem('')
  }, [])
  
  useEffect(() => {
    setSelectedIndex(0)
    axios.get(`${process.env.REACT_APP_GATEWAY_BASE_URL}/services/service-stage/util/machine`, {
      params: {
        query: inputItem
      }
    })
      .then(response => {
        if(response.data) setItems(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [inputItem])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: MachineItemType) => {
    setInputItem('')
    setShowOptions(false)
    setMachines(prev => machines.some(m => m.id === item.id) ? prev : [...prev, item])
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  const handleRemoveMachine = (id: number) => {
    setMachines(prev => prev.filter(m => m.id !== id))
  }

  return(
    <InputDiv>
      <Label>Máquinas</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Selecione'
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((m, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(m)}
              isSelected={index === selectedIndex}
            >
              {m.name} - {m.model}
            </Option>
          )}
        </SearchOptions>
      }
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
        {machines.map((machine) => (
          <div
            key={machine.id} 
            style={{ backgroundColor: '#fff',
            padding: '5px 10px', 
            borderRadius: '1rem', 
            fontSize: '14px', 
            fontWeight: '400', 
            color: '#696969', 
            border: '1px solid #C4C4C4',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
            }}>
            {machine.name} - {machine.model}
            <X size={16} style={{ cursor: 'pointer' }} onClick={() => handleRemoveMachine(machine.id)} />
          </div>
        ))}
      </div>
    </InputDiv>
  )
}

export default SelectMachineInService 
